import type { ReactNode } from "react";
import useLanguageTransition from "@/hooks/useLanguageTransition";

interface LanguageTransitionWrapperProps {
  children: ReactNode;
}

export default function LanguageTransitionWrapper({ children }: LanguageTransitionWrapperProps) {
  const { isTransitioning, transitionKey } = useLanguageTransition(380);

  return (
    <div
      key={`lang-wrapper-${transitionKey}`}
      className={`w-full min-h-screen transition-all duration-[380ms] ease-out ${
        isTransitioning ? "language-fade-out" : "language-fade-in"
      }`}
    >
      {children}
    </div>
  );
}